import { StateCreator } from 'zustand';
import { allSlices, agoraSlice } from './interface';
import { UID } from 'agora-rtc-react';

export const createAgoraSlice: StateCreator<allSlices, [], [], agoraSlice> = (set) => ({
  usersMap: {},
  users: [],
  speakers: [],
  current: 0,
  isScreenShared: false,
  setAgoraState: (data: Partial<agoraSlice>) =>
    set((state) => ({ agora: { ...state.agora, ...data } })),
  updateUsers: (remoteUsers) => {
    const newUsersMap = remoteUsers.reduce((acc, curr) => {
      return { ...acc, [curr.uid]: curr };
    }, {});

    set((state) => ({ agora: { ...state.agora, usersMap: newUsersMap, users: remoteUsers } }));
  },
  updateSpeakers: (volumes) =>
    set((state) => {
      const allVolumes = [
        ...volumes,
        ...state.agora.users.map((user) => ({
          uid: user.uid,
          level: 0
        }))
      ];

      allVolumes.sort(
        (a, b) =>
          b.level -
          a.level +
          (+state.agora.usersMap[b.uid]?.hasVideo || 0) -
          (+state.agora.usersMap[a.uid]?.hasVideo || 0)
      );

      const speakers = new Set(allVolumes.map(({ uid }) => uid));

      speakers.delete(state.room.userId?.toString() as UID);
      speakers.delete(state.room.presenterId?.toString() as UID);

      if (state.room.recorderId) speakers.delete(state.room.recorderId?.toString() as UID);

      return { agora: { ...state.agora, speakers: [...speakers] } };
    }),
  setScreenShare: (isScreenShared) =>
    set((state) => ({ agora: { ...state.agora, isScreenShared } }))
});

export default createAgoraSlice;
